import MyAxios from '../utils/instance.js'
const getgroup = {
	getgroups(groupid) {
		
	    return MyAxios({
	      url: `/toModel/getModeTypeFlag/${groupid}`,
	    })
	  },
}
export default getgroup;